module.exports = __webpack_public_path__ + "static/media/icon_checkin.7dfb9110.svg";